import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { ComputerStatus } from 'mbs-ui-shared@models/Computer';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { of } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-status-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchStatusTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchStatusTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;

  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();

    this.i18nPipe = i18nPipe;
  }
  public tag = SmartSearchTemplateName.Status;
  public isSequenceMultiple = false;
  public items = () =>
    of(
      [ComputerStatus.Online, ComputerStatus.Offline].map((value) => ({
        value,
        searchText: value,
        translation: `shared:computers.${value}`
      }))
    );
}
